<h1 *ngIf="!isAppMobile" tabindex="-1" class="dsd-b-30 dsd-color-font-secondary dsd-mb-xs">
  {{ 'caad.page-validation.sousTitre' | translate }}
</h1>
<h2 class="dsd-t-3 dsd-mb-md">
  {{ 'caad.page-validation.titre' | translate }}
</h2>

<dsd-container>
  <h3 class="dsd-t-4">
    {{ 'caad.page-validation.coordonnees.titre' | translate }}
  </h3>
  <p>
    <span class="libelle">{{ libelleAdresse | translate }}&nbsp;</span>
    <span class="valeur line-adresse">{{ adresseSaisie | adresse }}</span>
    <span class="valeur dsd-mt-xs" *ngIf="afficherDateChangement">
      <span>{{ 'caad.page-validation.coordonnees.aPartirDe' | translate }}&nbsp;</span>
      <span [innerHTML]="dateChangement | dateCustom"></span>
    </span>
  </p>
  <p>
    <span class="libelle">{{ 'caad.page-validation.coordonnees.courriel' | translate }}&nbsp;</span>
    <span class="valeur">{{ courriel || ('caad.page-validation.coordonnees.NonPrecisee' | translate) }}</span>
  </p>
  <p>
    <span class="libelle">{{ 'caad.page-validation.coordonnees.telephone.telephonePrincipal' | translate }}</span>
  </p>
  <!-- Bouton Modifier -->
  <dsd-button variant="compact" full-width="xs" (dsdButtonClick)="naviguerVersModifier()">
    {{ 'caad.button.modifier' | translate }}
  </dsd-button>
</dsd-container>

<!--<dsd-container>
  <h3 class="dsd-t-4 dsd-mb-md">
    {{ 'caad.page-validation.comptes.titre' | translate }}
  </h3>
  <p>{{ 'caad.page-validation.comptes.libelle' | translate }}</p>
</dsd-container>-->

<div class="zone-btn">
  <!-- Bouton Confirmer -->
  <dsd-button variant="primary" full-width="xs" (dsdButtonClick)="naviguerVersConfirmation()">
    {{ 'caad.button.confirmer' | translate }}
  </dsd-button>
  <!-- Bouton Annuler -->
  <dsd-button full-width="xs" (dsdButtonClick)="annuler()">
    {{ 'caad.button.annuler' | translate }}
  </dsd-button>
</div>
